<template>
<div>
  <navigation></navigation>
  <div class="p-t-lg">
    <contact-app></contact-app>
  </div>
</div>
</template>

<script>
import Navigation from "./Navigation";
import ContactApp from "../contact/ContactApp";

export default {
  name: 'ContactContainer',

  components: {
    Navigation,
    ContactApp
  },

  computed: {

  },

  created() {
    this.$store.dispatch("appData", {"title": this.$t("Kontakt")});
  }
};
</script>
